import styled from 'styled-components';

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0.5rem auto;
  padding: 0 5%;

  &.pbl__container-preselected {
    padding: 0.625rem 0 0.8125rem !important;
    justify-content: center;
  }

  @media (min-width: 768px) {
    margin-top: 1.25rem;
    padding: 0 2rem;
  }

  @media (min-width: 1024px) {
    padding: 0 2.875rem;
    padding-right: 2.1875rem;
  }
`;

export default FlexContainer;
